module.exports = __webpack_public_path__ + "static/media/emoji.10c362f2.png";